<ng-container
  *ngIf="isLoadingAttributeDescriptions$ | async; else newsDetailsTemplate"
>
  <div class="d-flex justify-content-center align-items-center min-vh-70">
    <i class="fas fa-spinner fa-spin"></i>
  </div>
</ng-container>
<ng-template #newsDetailsTemplate>
  <div class="news-details">
    <app-post-details-content
      [senderProfileImg]="details?.from?.image"
      [senderId]="details?.from?.id"
      [senderName]="getSender()"
      [dateTime]="
        details?.dateTime | localizedDate : DateFormat.FullDateTimeCommon4
      "
      [showDate]="showDate"
      [copied]="copied"
      [copyPostLink]="copyPostLink.bind(this)"
      [rawHtml]="rawHtml"
      [streams]="streams"
      [category]="details?.content?.category"
      [canViewDetails]="canViewDetails()"
      [showBackBtn]="true"
      [onBack]="goBack.bind(this)"
      [peopleURL]="peopleURL"
      [postData]="details"
      [currentOrg]="currentOrg"
    ></app-post-details-content>
  </div>
</ng-template>
